import { createFileRoute } from '@tanstack/react-router';

// relative imports
import TirCorrectionFilesTable from '../../../components/file-management/correction-file-table/TirCorrectionFilesTable';
import Loader from '../../../components/shared/custom-components/Loader';

export const Route = createFileRoute('/_authenticated/files/corrections')({
  pendingComponent: () => (
    <Loader marginTop={3} fillSpace LoaderContainerClasses={{}} />
  ),
  component: TirCorrectionFilesTable,
});
